// extracted by mini-css-extract-plugin
module.exports = {"menu-collapse":"style_menu-collapse__2k97B"};